<!-- <div class="container-artefact-approvals"> -->
  <div *ngIf="reviewStatusOptions?.length" class="artefact-filter-section artefact-filter-status">
    View:
    <span
      *ngFor="let reviewStatus of reviewStatusOptions"
      class="checkbox-container"
    >
      <input
        type="checkbox"
        [value]="reviewStatus"
        [checked]="selectedReviewStatus.includes(reviewStatus)"
        (change)="onCheckboxChange($event, reviewStatus)"
      />
      {{ reviewStatus }}
    </span>
  </div>

  <div class="artefact-filter-section artefact-filter-status">
    <div class="px-4 col-md-12 d-flex align-items-center flex-wrap row-gap-3">
      <ng-container
        *ngIf="
          appliedFilters?.dateFilterType?.value &&
          appliedFilters?.dateFilterType?.value !== 'custom'
        "
      >
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.dateFilterType?.label,
              filterType: 'dateFilterType',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container
        *ngIf="
          appliedFilters?.userStatusType?.value
        "
      >
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.userStatusType?.label,
              filterType: 'userStatusType',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container
        *ngIf="
          appliedFilters?.visibility?.value
        "
      >
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.visibility?.label,
              filterType: 'visibility',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container
        *ngIf="
          appliedFilters?.isActive?.value
        "
      >
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.isActive?.label,
              filterType: 'isActive',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="appliedFilters?.organizationType?.length">
        <ng-container *ngFor="let history of appliedFilters!.organizationType">
          <ng-container
            *ngTemplateOutlet="
              filterChips;
              context: {
                label: history.label,
                value: history.value,
                filterType: 'organizationType',
              }
            "
          ></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="appliedFilters?.category?.length">
        <ng-container *ngFor="let history of appliedFilters!.category">
          <ng-container
            *ngTemplateOutlet="
              filterChips;
              context: {
                label: history.label,
                value: history.value,
                filterType: 'category',
              }
            "
          ></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="appliedFilters?.artifactType?.length">
        <ng-container *ngFor="let history of appliedFilters!.artifactType">
          <ng-container
            *ngTemplateOutlet="
              filterChips;
              context: {
                label: history.label,
                value: history.value,
                filterType: 'artifactType',
              }
            "
          ></ng-container>
        </ng-container>
      </ng-container>

      <ng-container
        *ngIf="
          appliedFilters?.actionDate?.fromDate &&
          appliedFilters?.dateFilterType?.value === 'custom'
        "
      >
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label:
                appliedFilters.actionDate.fromDate +
                ' - ' +
                appliedFilters.actionDate.toDate,
              filterType: 'actionDate',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="appliedFilters?.instanceTypes?.value">
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.instanceTypes?.label,
              filterType: 'instanceTypes',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-container *ngIf="appliedFilters?.usageCategory?.value">
        <ng-container
          *ngTemplateOutlet="
            filterChips;
            context: {
              label: appliedFilters?.usageCategory?.label,
              filterType: 'usageCategory',
            }
          "
        ></ng-container>
      </ng-container>

      <ng-template
        let-label="label"
        let-filterType="filterType"
        let-value="value"
        #filterChips
      >
        <span class="filter-chip chip chip-gray d-flex align-items-center">
          {{ label }}
          <button
            class="cross-icon button-no-style text-xl ms-2"
            [innerHTML]="crossBlackSVG | safeHTML"
            (click)="
              onRemoveFilterClick(filterType, value); $event.stopPropagation()
            "
          ></button>
        </span>
      </ng-template>
    </div>
  </div>
<!-- </div> -->
